import { cn } from '@sparkai/utils'

import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'
import { Notification } from '../Notification'

export type StatusProps = BaseNotificationItemProps & {
  name: string
  status: 'online' | 'offline'
  location?: string
  type: 'status'
}

export function Status({ name, status, location, ...props }: StatusProps) {
  return (
    <NotificationItem
      {...props}
      avatar={{
        ...props.avatar,
        addon: (
          <Notification.Addon.Dot
            size={props.size}
            className={cn({
              'bg-gray-400': status === 'offline',
              'bg-green-400': status === 'online',
            })}
          />
        ),
      }}
      title={`${name} ${status}`}
      descriptionAddon={location && <p className='text-sm text-gray-500'>{location}</p>}
    />
  )
}
